  export const formatUnits = (units) => {
    const num = Number(units || 0);
    if (num === 0) return '0';
    if (num < 0.01) return num.toLocaleString(undefined, { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 8 
    });
    return num.toLocaleString(undefined, { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 4 
    });
  };